import { useEffect, useRef, useState, type RefObject } from "react";

/**
 * Whether an element's content is taller than the element, kept current as either changes.
 * Used where text is cut to fit a fixed space and the page has to know that it was.
 */
export function useOverflows<Element extends HTMLElement>(): [RefObject<Element | null>, boolean] {
  const element = useRef<Element>(null);
  const [overflows, setOverflows] = useState(false);

  useEffect(() => {
    const target = element.current;
    if (!target) return;
    const measure = () => {
      setOverflows(target.scrollHeight > target.clientHeight + 1);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  return [element, overflows];
}
